module.exports = __webpack_public_path__ + "media/images/flags/64/Armenia-9abe9263280eee5208f20fbb9aceea0e.png";